<div class="codex-main-container">
    <div *ngIf="currentReport" class="select-codex-view-container">
        <span class="go-back-btn" (click)="goBack()">
            <i class="bi bi-chevron-left"></i>
            Go back
        </span>
        <div class="select-codex-view-btns-container">
            <span class="select-codex-view-btn-title">Change view:</span>
            <div class="select-codex-view-btn" [ngClass]="{'active' : codexView === 'quarter'}" (click)="setCodexView('quarter')">
                <img src="../../../assets/svg/icon_calendar_balck.svg">
                <span class="select-codex-view-btn-title">Quarter View</span>
            </div>
            <div class="select-codex-view-btn" [ngClass]="{'active' : codexView === 'indicator'}" (click)="setCodexView('indicator')">
                <img src="../../../assets/svg/readiness_score.svg">
                <span class="select-codex-view-btn-title">Indicator View</span>
            </div>
        </div>
    </div>
    <div *ngIf="currentReport" class="codex-components-container">
        <app-codex-quarter-view *ngIf="currentReport && codexView === 'quarter'"
            [currentQuarter]="currentReport"
            [quarterList]="teamCodexReports"
            (emitQuarterChange)="onReportChange($event)">
        </app-codex-quarter-view>
        <app-codex-indicator-view *ngIf="currentReport && showCategoryStatements && codexView === 'indicator'"
            [currentReport]="currentReport"
            [codexesByCategory]="codexesByCategory"
            (categoryChanged)="getTeamLeadershipCodexQuestionsByCategoryUuid($event)">
        </app-codex-indicator-view>
    </div>
</div>